<template>
	<a class='tooltip person'
		:data-description='person.name'
		:href='`/profile/${person.id}/`'
		v-if='person.photo_small'>
		<span class='tooltiptext'>{{person.name}}</span>
		<header class='people-picture-radius' :style='`background-image: url(${person.photo_small});`'></header>
	</a>
</template>

<script>
export default {
	name:  'Person',
	props: {
		person: {
			type: Object
		}
	}
};
</script>
